import React, { FC, useEffect, useRef, useState } from 'react';
import styles from './styles.module.css';
import { View } from '../project_nav/types';
import cx from 'classnames';
import { OpenWebsite } from './OpenWebsite';
import { OpenWebsiteWithProxy } from './OpenWebsiteWithProxy';
import { AddTaskOrAssetButton } from './AddTaskOrAssetButton';
import AssetsHeader from '../../../../clients/design_assets/AssetsHeader';
import AssetsGuestHeader from '../../../../clients/design_assets/AssetsGuestHeader';
import { useOrganizationState } from '../../../../../clients/providers/Organization';
import { AcceptingFeedbackShortcut } from '../../kanban/task_list/AcceptingFeedbackShortcut';
import { getIsAcceptingFeedback } from '../../project_settings/forms/sidebar/AcceptingFeedback';
import {
  getProjectSearchUnfocusedActive,
  subscribeToProjectSearchUnfocusedActive
} from 'appJS/components/ProjectSearchBar/unfocusedActiveState';

type Props = {
  projectSites: {
    url: string;
    id: number;
  }[];
  devurl: string;
  view: View | null;
  isMobileView: boolean;
  isReviewApp: boolean;
  isAdminUser: boolean;
  apiKey: string;
  project: any;
  manageProject: boolean;
};

export const ProjectHeader: FC<Props> = ({
  projectSites,
  devurl,
  view,
  isMobileView,
  isReviewApp,
  isAdminUser,
  apiKey,
  project,
  manageProject
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const container = containerRef.current;
  const [
    isProjectSearchUnfocusedActive,
    setIsProjectSearchUnfocusedActive
  ] = useState(getProjectSearchUnfocusedActive);

  const { hasNewOnboardingExperiment } = useOrganizationState();
  const {
    organization: { acceptingFeedbackAllowed, feedbackDeadlineAllowed },
    acceptingFeedback,
    acceptingFeedbackEndDate
  } = project;
  const hideActionsContainer = view === View.Assets || view === View.Home;

  const isAcceptingFeedback = getIsAcceptingFeedback({
    acceptingFeedback,
    feedbackDeadlineAllowed,
    acceptingFeedbackEndDate
  });

  useEffect(
    () =>
      subscribeToProjectSearchUnfocusedActive(
        setIsProjectSearchUnfocusedActive
      ),
    []
  );

  if (view === View.GettingStarted) {
    return <></>;
  }

  return (
    <div
      ref={containerRef}
      className={cx(styles.container, {
        [styles.isMobileView]: isMobileView
      })}
    >
      {view === View.Assets && <AssetsHeader project={project} />}
      {view === View.Home && <AssetsGuestHeader project={project} />}

      {!isMobileView && !hideActionsContainer && (
        <div className={styles.actions}>
          <AcceptingFeedbackShortcut
            show={
              acceptingFeedbackAllowed &&
              (view === View.Kanban || view === View.Triage) &&
              !isProjectSearchUnfocusedActive
            }
            isAcceptingFeedback={isAcceptingFeedback}
            manageProject={manageProject}
          />
          {hasNewOnboardingExperiment ? (
            <OpenWebsiteWithProxy
              container={container}
              isMobileView={isMobileView}
              project={project}
              projectSites={projectSites}
              devurl={devurl}
              isReviewApp={isReviewApp}
              isAdminUser={isAdminUser}
              apiKey={apiKey}
            />
          ) : (
            <OpenWebsite
              container={container}
              isMobileView={isMobileView}
              projectId={project.id}
              projectSites={projectSites}
              devurl={devurl}
              isReviewApp={isReviewApp}
              isAdminUser={isAdminUser}
              apiKey={apiKey}
            />
          )}
          <AddTaskOrAssetButton view={view} />
        </div>
      )}
    </div>
  );
};
